@let isLgOrAbove = viewportSelectors.isLgAndUp | select;
@let isMdOrAbove = viewportSelectors.isMdAndUp | select;

@if (includeHamburgerMenu | select) {
  <div class="flex flex-row gap-3">
    <mx-icon-button #hamburgerButton="matMenuTrigger" [icon]="hamburgerButton.menuOpen ? 'close' : 'menu'" [matMenuTriggerFor]="hamburgerMenu"/>
    <ng-container *ngTemplateOutlet="getLibraryCardButton"/>
  </div>
}

@if (patronSelectors.hasPatron | select) {

  <span mxTruncate class="text-title-large">{{ branchSelectors.name | select }}</span>

  <div class="h-full flex items-center">
    <mx-icon-button #notificationMenuTrigger="cdkOverlayOrigin" cdkOverlayOrigin icon="notifications" color="on-surface-variant"
                    [showStatusDot]="notificationsSelectors.hasUnreadNotifications | select:false" (click)="toggleNotificationPanel()" class="mx-2 lg:mx-4"/>

    @if (isLgOrAbove) {
      <mx-text-button [label]="patronSelectors.fullName | select" endIcon="expand_more" [matMenuTriggerFor]="profileMenu"/>
    } @else {
      <!-- eslint-disable-next-line @nx/workspace-mx-use-button-components -- This is not a standard FAB, so it shouldn't be converted to <mx-fab>. -->
      <button [matMenuTriggerFor]="profileMenu" mat-fab color="primary" class="text-title-medium shadow-none rounded-full h-8 w-8 pt-[1px]">
        {{ patronSelectors.initials | select }}
      </button>
    }

    <!-- Notifications Panel - Defined once for sm and once for md+ because otherwise the ConnectedOverlay panel can't resolve the classes correctly. -->
    @if (isMdOrAbove) {
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="notificationMenuTrigger" [cdkConnectedOverlayOpen]="notificationPanelOpened"
                   [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeNotificationPanel()" (detach)="closeNotificationPanel()"
                   (overlayOutsideClick)="closeNotificationPanel()" [cdkConnectedOverlayPanelClass]="['w-[400px]']">
        <ng-container *ngTemplateOutlet="notificationsCard"/>
      </ng-template>
    } @else {
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="notificationMenuTrigger" [cdkConnectedOverlayOpen]="notificationPanelOpened"
                   [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeNotificationPanel()" (detach)="closeNotificationPanel()"
                   (overlayOutsideClick)="closeNotificationPanel()" [cdkConnectedOverlayPanelClass]="['w-screen','left-0','top-[3.75rem]']">
        <ng-container *ngTemplateOutlet="notificationsCard"/>
      </ng-template>
    }

    <!-- Notifications List Card -->
    <ng-template #notificationsCard>
      <mat-card class="shadow-xl w-full h-full">
        <mat-card-content>
          <px-notification-list/>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </div>
} @else {
  @if (isLgOrAbove) {
    <ng-container *ngTemplateOutlet="getLibraryCardButton"/>
  }
  <mx-filled-button label="Login" (click)="onClickLogin()"/>
}

<mat-menu #profileMenu="matMenu" [overlapTrigger]="false">
  <a mat-menu-item pxNamedRouterLink="DASHBOARD">My Account</a>
  <a mat-menu-item pxNamedRouterLink="LOGOUT">Sign Out</a>
</mat-menu>

<mat-menu #hamburgerMenu="matMenu" [overlapTrigger]="false">
  <!-- Org Website -->
  @let homeUrl = organizationSelectors.websiteUrl | select;
  @if (homeUrl) {
    <a mat-menu-item [href]="homeUrl">Library Home</a>
  } @else {
    <button mat-menu-item disabled>Library Home</button>
  }

  <!-- Internal Links -->
  @if (patronSelectors.hasPatron | select) {
    <button mat-menu-item [matMenuTriggerFor]="myAccountSubMenu">My Account</button>
  }
  <a mat-menu-item pxNamedRouterLink="CATALOG">Catalog</a>

  <!-- Organization Configurable Global Links -->
  @for (link of organizationSelectors.globalNavLinks | select; track $index) {
    <a mat-menu-item [href]="link.href">{{ link.label }}</a>
  }
</mat-menu>

<mat-menu #myAccountSubMenu="matMenu" [overlapTrigger]="false">
  <a mat-menu-item pxNamedRouterLink="DASHBOARD">Dashboard</a>
  <a mat-menu-item pxNamedRouterLink="CHECKED_OUT">Checked Out</a>
  <a mat-menu-item pxNamedRouterLink="HOLDS">Holds</a>
  <a mat-menu-item pxNamedRouterLink="BALANCE">Balance</a>
  <a mat-menu-item pxNamedRouterLink="ITEM_REQUESTS">Requests</a>
  <a mat-menu-item pxNamedRouterLink="MY_PROFILE">My Profile</a>
  <a mat-menu-item pxNamedRouterLink="RELATED_ACCOUNTS">Related Accounts</a>
  <a mat-menu-item pxNamedRouterLink="FAVORITES">Favorites</a>
  <a mat-menu-item pxNamedRouterLink="SETTINGS">Settings</a>
</mat-menu>

<ng-template #getLibraryCardButton>
  <mx-link-button label="Get a Library Card" (click)="onClickCreateAccount()"/>
</ng-template>
